import { Routes, Route } from "react-router-dom";
import Navbar from "../components/Navbar";
import LoginPage from "../pages/LoginPage";
import NotFoundPage from "../pages/NotFoundPage";
import ExplorerPage from "../pages/ExplorerPage";
import DecisionTrackerPage from "../pages/DecisionTrackerPage";
import ContainerRecommendationPage from "../pages/ContainerRecommendationsPage";
import DataLibraryPage from "../pages/DataLibraryPage";
import LogoutPage from "../pages/LogoutPage";
import LicenseTermsPage from "../pages/LicenseTermsPage";
import DataProcessingAgreementPage from "../pages/DataProcessingAgreementPage";
import InventoryOptimizationPage from "../pages/InventoryOptimizationPage";
import ActionDrawerPage from "../pages/ActionDrawerPage";

const AppRoutes = () => (
  <Routes>
    {/* Public Routes */}
    <Route path="/login" element={<LoginPage />} />
    <Route path="/license-terms" element={<LicenseTermsPage />} />
    <Route path="/data-processing-agreement" element={<DataProcessingAgreementPage />} />

    {/* Routes with Navbar */}

    <Route path="/" element={<Navbar />}>
      <Route path="/" element={<ContainerRecommendationPage />} />
      <Route path="logout" element={<LogoutPage />} />
      {/*<Route path="explorer" element={<ExplorerPage />} />*/}
      <Route path="decision-tracker" element={<DecisionTrackerPage />} />
      <Route path="data-library" element={<DataLibraryPage />} />
      <Route path="container-recommendations/:containerId" element={<InventoryOptimizationPage />} />
      <Route path="action-drawer/:containerId" element={<ActionDrawerPage />} />
    </Route>

    {/* Fallback Route */}
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default AppRoutes;
